import React from 'react';
import { ReactComponent as Backspace } from './backspace.svg';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import NumButton from './NumButton';
import * as Popover from '@radix-ui/react-popover';

interface NumpadProps {
    // ввод цифры
    addDigit: (digit: string) => void;
    // удаление последней цифры числа
    delDigit: () => void;
    // сброс значения
    resetValue: () => void;
    // установление максимального значения
    setMaxStepValue?: () => void;
    // закрытия нампада
    closeNumpad?: () => void;
}

function Numpad(props: NumpadProps) {
    const {t} = useTranslation();
    const nums = [
        [7, 8, 9],
        [4, 5, 6],
        [1, 2, 3]
    ];

    const hasAdditionalButtons = !!(props.setMaxStepValue || props.closeNumpad);

    return (
        <div className="rounded-[8px] inline-flex text-black bg-[#D8D8D8] h-[246px] w-[293px] desktop:h-[278px] desktop:w-[331px]">
            <div className="flex flex-col flex-grow-[3] basis-0">
                {nums.map((row, i) => (
                    <div key={i} className={"flex flex-grow-[1] border-b-1 border-[#979797]"}>
                        {row.map(num => (<NumButton key={num} className={clsx('flex-basis-0 border-r-[1px] border-[#979797] hover:shadow-[inset_0_0_7px_0px_#0000002e]', hasAdditionalButtons ? '' : 'last:border-r-0')} digit={String(num)} addDigit={props.addDigit} />))}
                    </div>
                ))}
                <div className="flex flex-grow-[1]">
                    <button className={clsx("basis-0 bg-[#EA4F51] border-r-[1px] border-[#979797] rounded-bl-[8px] text-white hover:shadow-[inset_0_0_7px_0px_#0000002e] hover:cursor-pointer", "flex-grow flex items-center justify-center")} onClick={props.resetValue}>
                        C
                    </button>
                    <NumButton className="basis-0 border-r-[1px] border-[#979797] hover:shadow-[inset_0_0_7px_0px_#0000002e] hover:cursor-pointer" digit={'0'} addDigit={props.addDigit} />
                    <button className={clsx("basis-0  border-[#979797] hover:shadow-[inset_0_0_7px_0px_#0000002e] hover:cursor-pointer", "flex-grow flex items-center justify-center", hasAdditionalButtons ? 'border-r-[1px]' : 'border-r-0')} onClick={props.delDigit}>
                        <Backspace />
                    </button>
                </div>
            </div>
            {hasAdditionalButtons && (
                <div className="flex flex-col flex-grow-[1] basis-0">
                    {props.setMaxStepValue && (
                        <button
                            className={clsx(
                                'border-b-1 border-[#979797]',
                                'bg-[#F79231] border-r-1 border-gray-600 rounded-tr-[8px] text-white hover:shadow-[inset_0_0_7px_0px_#0000002e] hover:cursor-pointer',
                                'flex-grow flex items-center justify-center'
                            )}
                            onClick={props.setMaxStepValue}
                        >
                            <h4>{t('coupons.maxStep')}</h4>
                        </button>
                    )}

                    {props.closeNumpad && (
                        <button className={clsx("bg-[#42B6F6] border-r-1 border-gray-600 rounded-br-[8px] text-white hover:shadow-[inset_0_0_7px_0px_#0000002e] hover:cursor-pointer", "flex-grow flex items-center justify-center")} onClick={props.closeNumpad}>
                            <Popover.Close aria-label="Close">
                                {t('coupons.numPad.ok')}
                            </Popover.Close>
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}

export default Numpad;
